<app-header [transparent]="transparentHeader"></app-header>
<router-outlet></router-outlet>
@if (isHomePage) {
<app-stats></app-stats>
}
<app-footer></app-footer>
